import { createContext, useContext } from 'react';
import type { ViewBody } from '@ayumia/contracts';
import { ActionBar } from '../ActionBar';
import type { Row } from './useCollection';

/**
 * Actions de la vue offertes aux cellules bouton (ADR-100) : fournies par le conteneur, avec le
 * type des lignes et la relecture après exécution. Une cellule ne déclare pas d'action : elle cite
 * une action de la vue, qui garde sa condition et sa commande réautorisée au serveur.
 */
export interface RowActions {
  actions: NonNullable<ViewBody['actions']>;
  type: string;
  onDone: () => void;
}

export const RowActionsContext = createContext<RowActions | null>(null);

export function RowActionCell({ actionId, row }: { actionId: string; row: Row }) {
  const context = useContext(RowActionsContext);
  const action = context?.actions.find((candidate) => candidate.action_id === actionId);
  if (context === null || action === undefined || typeof row.id !== 'string') return null;
  return (
    // Le bouton agit sur la ligne sans l'ouvrir.
    <span className="ay-cell-action" onClick={(event) => event.stopPropagation()} onKeyDown={(event) => event.stopPropagation()}>
      <ActionBar actions={[action]} record={row} target={{ type: context.type, id: row.id, ...(typeof row.version === 'number' ? { version: row.version } : {}) }} onDone={context.onDone} />
    </span>
  );
}
